<template>
  <div class="CompanyStrength">

    <div class="middle ">

      <div class="video">
        <p>Company profile</p><br>
        <span>
          <hr><i>公司简介</i>
          <hr></span>
        <div>
          <video src="../../assets/imges/飞天电子科技有限公司视频.mp4"
                 controls
                 height="500px"
                 width="50%"></video>
        </div>
      </div>
      <!-- 钻孔设备 -->
      <div class="back">
        <div class="instructionsIimags">
          <img style=" position: relative;bottom:2rem"
               src="../../assets/imges/atlas/instructionsIimags/大量钻机.png"
               alt="">
          <span>
            <i>钻孔设备</i>
            <br>
            <i style="font-size:1rem;color:#000; text-indenx:2;">
              采用台湾大量数控钻机，高效线马钻孔机，CCD定位精度±0.005mm，钻孔精度±0.018mm，钻孔深度精度±0.03mm，<br>
              掌握四大核心技术能力：稳、准、快、管，全面杜绝槽孔歪斜/漏钻孔/孔径不符等问题</i>
          </span>
        </div>
        <div class="flex ">
          <div class="imges flex"
               v-for="(i,index) in img"
               :key="index">
            <div class="text">
              <img :src="i.url"
                   alt=""><br>
              <i>{{i.text}}</i>
            </div>
          </div>
        </div>
      </div>
      <!-- 沉铜 -->
      <div class="back">
        <div class="instructionsIimags">
          <img src="../../assets/imges/atlas/instructionsIimags/大量钻机.png"
               alt="">
          <span>

            <i>沉铜VCP</i>

            <br>
            <i style="font-size:1rem;color:#000; text-indenx:2;">
              全自动沉铜电镀设备，深孔能力13：1，镀铜均匀性达98%以上</i>
          </span>
        </div>
        <div class="flex ">
          <div class="imges flex"
               v-for="(i,index) in img1"
               :key="index">
            <div class="text">
              <img :src="i.url"
                   alt=""><br>
              <i>{{i.text}}</i>
            </div>
          </div>
        </div>
      </div>
      <!-- 线路 -->
      <div class="back">
        <div class="instructionsIimags">
          <img src="../../assets/imges/atlas/instructionsIimags/线路LDI.jpg"
               alt="">
          <span>
            <i>线路</i>
            <br>
            <i style="font-size:1rem;color:#000; text-indenx:2;">
              采用全自动化高多层线路LDI，适合多品种内外线路及曝光，自动控制解决涨缩问题</i>
          </span>
        </div>
        <div class="flex ">
          <div class="imges flex"
               v-for="(i,index) in img2"
               :key="index">
            <div class="text">
              <img :src="i.url"
                   alt=""><br>
              <i>{{i.text}}</i>
            </div>
          </div>
        </div>
      </div>
      <!-- 阻焊文字 -->
      <div class="back">
        <div class="instructionsIimags">
          <img src="../../assets/imges/atlas/instructionsIimags/成型CUT机.jpg"
               alt="">
          <span>

            <i>阻焊颜色</i>
            <br>
            <i style="font-size:1rem;color:#000; text-indenx:2;margin-top:2rem">
              万级净化无尘室+高速文字喷墨机，有效规避板面垃圾、文字模糊、印偏等问题，防止非焊接点被沾污焊锡，便于贴片封装，有效保护电路</i>
          </span>
        </div>
        <div class="flex ">
          <div class="imges flex"
               v-for="(i,index) in img3"
               :key="index">
            <div class="text">
              <img :src="i.url"
                   alt=""><br>
              <i>{{i.text}}</i>
            </div>
          </div>
        </div>
      </div>
      <!-- 成型 -->
      <div class="back">
        <div class="instructionsIimags">
          <img src="../../assets/imges/atlas/instructionsIimags/成型CUT机.jpg"
               alt="">
          <span>
            <i>成型</i>
            <br>
            <i style="font-size:1rem;color:#000; text-indenx:2;">
              最大化符合客户要求的出货尺寸，对PCB板进行CNC锣边或采用更直观、精准的CCD对位模式的高效双向来回V-CUT，工艺能力满足0.10mm以内</i>
          </span>
        </div>
        <div class="flex ">
          <div class="imges flex"
               v-for="(i,index) in img4"
               :key="index">
            <div class="text">
              <img :src="i.url"
                   alt=""><br>
              <i>{{i.text}}</i>
            </div>
          </div>
        </div>
      </div>
      <!-- 测试 -->
      <div class="back">
        <div class="instructionsIimags">
          <img src="../../assets/imges/atlas/instructionsIimags/全自动测试机.png"
               alt="">
          <span>

            <i>测试</i>
            <br>
            <i style="font-size:1rem;color:#000; text-indenx:2;">
              采用协辰全自动测试机，双导轨，CCD对位，高精度、高速度，可超大板测试</i>
          </span>
        </div>
        <div class="flex ">
          <div class="imges flex"
               v-for="(i,index) in img5"
               :key="index">
            <div class="text">
              <img :src="i.url"
                   alt=""><br>
              <i>{{i.text}}</i>
            </div>
          </div>
        </div>
      </div>
      <!--实验室 -->
      <div class="back">
        <span>
          <i>实验室</i>
          <br>

        </span>
        <div class="flex ">
          <div class="imges flex"
               v-for="(i,index) in img6"
               :key="index">
            <div class="text">
              <img :src="i.url"
                   alt=""><br>
              <i>{{i.text}}</i>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // 技术图片
      img: [
        // { url: require('../../assets/imges/atlas/drilling/1.png') },
        {
          url: require('../../assets/imges/atlas/drilling/b2b228219b1a8c964bb2e9f08b1fa31.jpg'),
          text: '高精度线性马达钻机'
        },
        {
          url: require('../../assets/imges/atlas/drilling/2.jpg'),
          text: '新大族钻机'
        },
        {
          url: require('../../assets/imges/atlas/drilling/3.jpg'),
          text: '新大族钻机-2'
        },
        {
          url: require('../../assets/imges/atlas/drilling/4.jpg'),
          text: '钻孔 (加)'
        }

        // { url: require('../../assets/imges/atlas/drilling/a5fc5e3fe02cd18d3b289333deb89b8.jpg') },
        // { url: require('../../assets/imges/atlas/drilling/e242fe5cbe9f74ec723b69fc6608104.jpg') },
        // { url: require('../../assets/imges/atlas/drilling/ef548526f28e8e4fb7eca2548daec54.jpg') },
      ],
      //   设备图片
      img1: [
        {
          url: require('../../assets/imges/atlas/HeavyCopper/1.png'),
          text: 'VCP垂直连续电镀'
        },
        {
          url: require('../../assets/imges/atlas/HeavyCopper/2.png'),
          text: '垂直沉厚铜线'
        },
        {
          url: require('../../assets/imges/atlas/HeavyCopper/3.png'),
          text: '全自动脉冲图形电镀'
        },
        {
          url: require('../../assets/imges/atlas/HeavyCopper/4.png'),
          text: 'VCP电镀线（换）'
        }
      ],
      //   线路
      img2: [
        {
          url: require('../../assets/imges/atlas/line/3.jpg'),
          text: '自动贴膜机'
        },
        {
          url: require('../../assets/imges/atlas/line/4.jpg'),
          text: '自动连线LDI曝光机'
        },
        {
          url: require('../../assets/imges/atlas/line/1.jpg'),
          text: 'DPTH线（换）'
        },
        { url: require('../../assets/imges/atlas/line/2.jpg'), text: '显影机' }
      ],
      //   阻焊文字
      img3: [
        {
          url: require('../../assets/imges/atlas/Resistance/1.jpg'),
          text: '全自动文字丝印机'
        },
        {
          url: require('../../assets/imges/atlas/Resistance/2.png'),
          text: '阻焊CCD曝光机（换）'
        },
        {
          url: require('../../assets/imges/atlas/Resistance/3.png'),
          text: '阻焊全自动曝光机'
        },
        {
          url: require('../../assets/imges/atlas/Resistance/4.png'),
          text: '阻焊CCD曝光机'
        }
      ],
      //   成型
      img4: [
        {
          url: require('../../assets/imges/atlas/TheMolding/1.jpg'),
          text: 'CNC锣板成型'
        },
        {
          url: require('../../assets/imges/atlas/TheMolding/2.jpg'),
          text: 'CNC锣板成型-1'
        },
        {
          url: require('../../assets/imges/atlas/TheMolding/3.jpg'),
          text: '成型车间图'
        },
        {
          url: require('../../assets/imges/atlas/TheMolding/4.jpg'),
          text: '大板自动V-CUT机'
        }
      ],
      //   测试
      img5: [
        {
          url: require('../../assets/imges/atlas/test/1.jpg'),
          text: '测试车间'
        },
        {
          url: require('../../assets/imges/atlas/test/2.jpg'),
          text: '全自动测试机'
        },
        {
          url: require('../../assets/imges/atlas/test/3.png'),
          text: '四线低阻测试仪（可测定低阻）'
        },
        {
          url: require('../../assets/imges/atlas/test/4.jpg'),
          text: '自动飞针测试机'
        }
      ],
      //  实验室
      img6: [
        { url: require('../../assets/imges/atlas/laboratory/1.jpg') },
        { url: require('../../assets/imges/atlas/laboratory/2.jpg') },
        { url: require('../../assets/imges/atlas/laboratory/3.jpg') },
        { url: require('../../assets/imges/atlas/laboratory/5.png') }
        //    { url: require('../../assets/imges/atlas/laboratory/4.png') },
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
.CompanyStrength {
  .middle {
    width: 75%;
    margin: auto;
    .video {
      text-align: center;
    }

    .imges div img:hover {
      width: 19rem;
      border-radius: 0.3rem;
      box-shadow: 0 0 1rem #000;
    }
    .back {
      border: 0.1rem solid #ddd;
      box-shadow: 0 0 1rem #000;
      margin-top: 2rem;
      border-radius: 0.5rem;
      padding-bottom: 1rem;
      .imges {
        img {
          flex: 1;
          margin: auto;
          max-width: 18rem;
          height: 14rem;
          max-height: 18rem;
          display: block;
          margin: auto;
          margin-left: 0.8rem;
          margin-top: 0.8rem;
          border-radius: 0.4rem;
        }
        i {
          margin: auto;
          display: inline-block;
          width: 100%;
          text-align: center;
        }
      }
    }

    // 头部样式
    span {
      display: inline-block;
      padding-top: 0.5rem;
      margin: auto;
      margin-left: 1rem;
      hr {
        width: 5rem;
        display: inline-block;
        margin-bottom: 0.3rem;
      }
      i {
        font-style: unset;
        font-size: 1.5rem;
        color: #12a182;
      }
    }
  }
}
// 介绍图片
.instructionsIimags {
  img {
    width: 3rem;
    height: 2rem;
    position: relative;
    bottom: 0.8rem;
    left: 1.5rem;
  }
  span {
    padding-left: 1rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/view/home/CompanyStrength.vue